import { emailSchema, phoneRequiredSchema, select2RequiredSchema, statusSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, number } from 'yup';

const addClientChatterSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    dob: stringRequiredSchema,
    gender: select2RequiredSchema,
    funding_source: select2RequiredSchema,
    city_town: stringRequiredSchema,

    parents: array().of(object().shape({
        firstname: stringRequiredSchema,
        lastname: select2RequiredSchema,
        phone: phoneRequiredSchema,
        email: emailSchema,
        id: number().nullable().optional()
    })),

    coordinators: array().of(object().shape({
        firstname: stringRequiredSchema,
        lastname: select2RequiredSchema,
        phone: phoneRequiredSchema,
        email: emailSchema,
        id: number().nullable().optional()
    })),

    teachers: array().of(object().shape({
        firstname: stringRequiredSchema,
        lastname: select2RequiredSchema,
        phone: phoneRequiredSchema,
        email: emailSchema,
        id: number().nullable().optional()
    })),

    documents: array().of(object().shape({
        attachment_key: stringRequiredSchema,
        attachment_name: stringRequiredSchema
    })),

    status: statusSchema,
    is_confirmed: stringRequiredSchema,

    contracts: array().of(object().shape({
        attachment_key: stringRequiredSchema,
        attachment_name: stringRequiredSchema
    }))
})
.test(
    "at-least-one-guardian",
    "At least one guardian (Parent, Teacher, or Coordinator) is required",
    function (value) {
        const { parents, teachers, coordinators } = value || {};

        const hasParents = parents?.length > 0;
        const hasTeachers = teachers?.length > 0;
        const hasCoordinators = coordinators?.length > 0;

        if (hasParents || hasTeachers || hasCoordinators) return true;

        return this.createError({
            path: "guardians", // 👈 attach error where you want
            message: "At least one guardian is required"
        });
    }
);

export default addClientChatterSchema;